import client from './client';

// POS 매출 대시보드 - 매장별 일/월 매출(onetak 자체매출 vs POS 실매출).
// period: 'DAY' | 'MONTH', date: DAY 는 'YYYY-MM-DD', MONTH 는 'YYYY-MM'. 생략 시 오늘/이번달.
export async function getPosSalesDashboard(period = 'DAY', date) {
  const res = await client.get('/admin/pos-sales/dashboard', { params: { period, date } });
  return res.data; // ApiResponse<{ period, from, to, totalOnetakAmount, totalPosAmount, rows:[...] }>
}

// 매장 클릭 시 - 해당 매장의 상품별 매출 통계(같은 기간).
export async function getPosSalesByProduct(storeId, period = 'DAY', date) {
  const res = await client.get('/admin/pos-sales/product', { params: { storeId, period, date } });
  return res.data; // ApiResponse<[{ productId, productName, qty, amount, orderCount }]>
}

// 기간별 매출 통계 - 시작일~종료일(포함) 범위의 매장별 + 전체 상품별 매출.
// from/to: 'YYYY-MM-DD'. 생략 시 최근 7일.
export async function getPosSalesStats(from, to) {
  const res = await client.get('/admin/pos-sales/stats', { params: { from, to } });
  return res.data; // ApiResponse<{ from, to, totalOnetakAmount, totalPosAmount, stores:[...], products:[...] }>
}
